import { Component, OnInit, Input } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
})
export class PageContentComponent implements OnInit {

  @Input() type: string;
  @Input() id: string;
  data: any;
  isStrapi = false;

  constructor(private contentService: ContentService,
              private sanitizer: DomSanitizer,
              private languageService: LanguagesService,
              private router: Router,
              private remoteConfig: RemoteConfigService) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
   this.getInfo();
   this.remoteConfig.getIsStrapi().subscribe((res) => {
      this.isStrapi = res;
    });
  }

  getInfo(){
    this.contentService.getContentTypeId(this.id).then((data: any) => {
      this.data = (data[0]) ? data[0] : [];
      this.data.content = this.data.Content ? this.data.Content : this.data.content;
      console.log('this.data.content', this.data.content)
    });
  }

  goTo(route) {
    this.router.navigate([route], {replaceUrl: true})
  }

  get getTextsIUContent() {
    return this.languageService.textsIU.page_content;
  }

  goToCatalog(base,route) {
    let base_url='';
    switch(base) {
      case 'category':
        base_url = 'categories'; // TODO
        break;
      default:
         base_url = 'catalogue';
    }
    this.router.navigate([base_url + '/' + route], {replaceUrl: true})
  }

}
